import React, { useState, useEffect } from "react";
import AssignOtherUser from "./AssignOtherUser.jsx";
import AddUserModel from "./addUserModel.jsx";
import DeactivateUserModel from "./DeactivateUserModel.jsx";
import { Button, Space, message, Popconfirm, Table, Spin } from "antd";
import CustomSearch from "../../../components/search/CustomSearch.jsx";
import { formatIndianDate } from "../../../utils/Constant.jsx";
import SuccessButton from "../../../components/button/SuccessButton.jsx";
import { Link } from "react-router-dom";
import ButtonComp from "../../../components/button/ButtonComp.jsx";
import axiosInstance from "../../../utils/axiosInstance.js";
import { useSelector } from "react-redux";

const UserTab = ({ type }) => {
    const [users, setUsers] = useState([]);
    const [loading, setLoading] = useState(false);
    const [userCount, setUserCount] = useState(0);
    const [isOpenUserModel, setIsOpenUserModel] = useState(false);
    const [assingSenderId, setAssingSenderId] = useState(undefined);
    const select = useSelector((state) => state.auth.userInfo);
    const user_role = select.role;
    const [isAssignModal, setIsAssignModal] = useState(false);
    const [deactivateModal, setDeactivateModal] = useState(false);
    const [roleName, setRoleName] = useState(undefined)
    const comp_id = useSelector((store) => store.auth.userInfo.company_id);
    const compnayId = localStorage.getItem("companyId") || comp_id

    const config = {
        search: "",
        company_id: compnayId
    };

    useEffect(() => {
        setLoading(true);
        fetchUsers();
    }, []);

    const handleSearch = (value) => {
        config.search = value;
        fetchUsers();
    };

    const fetchUsers = async () => {
        try {
            setLoading(true);
            const response = await axiosInstance.get(`/user/get/`, { customParams: config })
            const { data, count } = response.data;

            if (Array.isArray(data)) {
                setUsers(data);
                setUserCount(count);

            } else {
                setUsers([]);
                setUserCount(0);
            }
            setLoading(false);
        }

        catch (error) {
            console.error(error);
            setLoading(false);
        }
    };

    const userWithIds = users.length > 0
        ? users.map((item, index) => ({
            ...item,
            index: index + 1,
        }))
        : [];

    const userColumnsAdmin = [
        {
            title: "S. No.",
            dataIndex: "index",
            key: "index",
        },

        {
            title: "User's Name",
            dataIndex: "first_name",
            key: "first_name",
        },
        {
            title: "User's Email",
            dataIndex: "email",
            key: "email",
        },
        {
            title: "Department",
            dataIndex: "department",
            key: "department",
            render: (department) => (department ? department.name : ""),
        },
        {
            title: "Employee ID",
            dataIndex: "employee_id",
            key: "employee_id",
        },
        {
            title: "Profile",
            dataIndex: "role",
            key: "role",
        },
        {
            title: "Activation Date",
            dataIndex: "activation_date",
            key: "activation_date",
            render: (date) => formatIndianDate(date),
        },
        ...(user_role === "admin" || user_role === "professional" ? [{
            title: "Change Status",
            dataIndex: "is_active",
            key: "is_active",
            render: (text, record) => (
                <>
                    <Space>
                        {record.is_active ? (
                            <div
                                onClick={() => { setAssingSenderId(record.id); setDeactivateModal(true); setRoleName(record.role); }}
                                className="inline-block rounded-full border-2 border-red px-6 pb-[6px] pt-2 bg-red-400 text-xs font-medium uppercase leading-normal text-black transition duration-150 ease-in-out hover:border-danger-600 hover:bg-neutral-500 hover:bg-opacity-10 hover:text-danger-600 focus:border-danger-600 focus:text-danger-600 focus:outline-none focus:ring-0 active:border-danger-700 active:text-danger-700 dark:hover:bg-neutral-100 dark:hover:bg-opacity-10"
                            >
                                Deactivate
                            </div>
                        ) : (
                            <Popconfirm
                                title="Activate this user?"
                                description="Are you sure you want to activate this user?"
                                onConfirm={() => { handleActivate(record.id); }}
                                okText="Yes"
                                cancelText="No"
                            >
                                <div
                                    className="inline-block rounded-full border-2 border-success px-6 pb-[6px] pt-2 bg-green-500 text-xs font-medium uppercase leading-normal text-black transition duration-150 ease-in-out hover:border-success-600 hover:bg-neutral-500 hover:bg-opacity-10 hover:text-success-600 focus:border-success-600 focus:text-black focus:outline-none focus:ring-0 active:border-success-700 active:text-black-700 dark:hover:bg-neutral-100 dark:hover:bg-opacity-10"
                                >
                                    Activate
                                </div>
                            </Popconfirm>
                        )}
                    </Space>
                </>
            ),
        },
        {
            title: "Assign Agreement",
            dataIndex: "age",
            key: "age",
            render: (text, record) => (
                <>
                    <SuccessButton text="Click" onClick={() => onOpenAssignModal(record)} />
                </>
            ),
        }] : [])
        ,
        {
            title: "View details",
            dataIndex: "first_name",
            key: "first_name",
            render: (text, record) => (
                <Link
                    to={{
                        pathname: type === "professional" ? `/admin/company/professional/user/${record.id}` : `/admin/user/${record.id}`,
                    }}
                >
                    <Button
                        type="submit"
                        className="inline-block rounded-full border-2 border-red px-6 pb-[6px] pt-2 bg-blue-400 text-xs font-medium uppercase leading-normal text-black transition duration-150 ease-in-out hover:border-danger-600 hover:bg-neutral-500 hover:bg-opacity-10 hover:text-danger-600 focus:border-danger-600 focus:text-danger-600 focus:outline-none focus:ring-0 active:border-danger-700 active:text-danger-700 dark:hover:bg-neutral-100 dark:hover:bg-opacity-10"
                    >
                        View details
                    </Button>
                </Link>
            ),
        },
    ];
    const showUserFormModal = (userId) => {
        setIsOpenUserModel(true);
    };

    const onSuccessAddUser = () => {
        fetchUsers();
        setIsOpenUserModel(false);
    }
    const onOpenAssignModal = (record) => {
        setIsAssignModal(true)
        setAssingSenderId(record.id)
        setRoleName(record.role);
    };

    const onSuccessAssign = () => {
        setAssingSenderId(null)
        setIsAssignModal(false)
    }
    const onSuccessUserDeactive = () => {
        setDeactivateModal(false);
        fetchUsers();
    }
    const handleActivate = (userId) => {
        axiosInstance.put(`/user/${userId}/active/`, { active: true })
            .then((response) => {
                if (response.status === 200) {
                    message.success("User activated successfully");
                    fetchUsers();
                }
            })
            .catch((error) => {
                message.error(error.response.data.error);
            });
    };

    console.log(userWithIds, "userWithIds", users, "users");
    return (
        <>
            <div className=" text-black pb-3 px-2 flex items-center justify-between">
                <span className="flex flex-row items-center gap-4">
                    <h1 className="font-semibold text-[15px] pt-[1%] dark:text-white">
                        Users
                    </h1>
                    <CustomSearch onSearch={handleSearch} />
                </span>
                {(user_role && ["admin", "superadmin"].includes(user_role.toLowerCase())) ? (
                    <ButtonComp
                        text="Add Users"
                        bgColor="#4E36A3"
                        textColor="white"
                        onClick={showUserFormModal}
                    />
                ) : null}
                <AddUserModel onSuccessAdd={onSuccessAddUser} userFormModal={isOpenUserModel} handleCancel={() => { setIsOpenUserModel(false) }} />

                <AssignOtherUser type={type} role={roleName} onSuccessAssign={onSuccessAssign} assingSenderId={assingSenderId} isAssignModal={isAssignModal} handleCancel={() => { setIsAssignModal(false) }} />

                <DeactivateUserModel type={type} role={roleName} userId={assingSenderId} handleCancel={() => { setDeactivateModal(false) }} isOpen={deactivateModal} onSuccess={onSuccessUserDeactive} />

            </div>

            <div>

                <div className=" border border-gray-300">
                    <Spin spinning={loading} tip="Loading...">
                        <Table
                            dataSource={userWithIds}
                            columns={userColumnsAdmin}
                            pagination={false}
                            size="small"
                            className="overflow-y-scroll text-[12px] [&_.ant-table-cell]:p-1 [&_.ant-table-cell]:text-[12px]"
                        // scroll={{ x: "max-content", y: 400 }}
                        />
                    </Spin>
                </div>
            </div>
        </>
    )
}
export default UserTab